module.exports = __webpack_public_path__ + "media/fonts/atlasPro/AtlasProAAA-Regular-210c5e3108858f3a9e0086a4160ce67f.woff";